<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Confirm refund to card</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="ion-text-center ion-padding">
    <h4 class="ion-padding">This will refund</h4>
    <h3 class="ion-padding">
      {{ amount | salonMonsterCurrency }}
    </h3>
    <h4 class="ion-padding">To the card ending in</h4>
    <h4 class="ion-padding">
      {{ cardInfo.last4Digits }} exp {{ cardInfo.expDate }}
    </h4>
  </div>
</ion-content>

<ion-footer class="ion-no-border ion-no-padding ion-no-margin">
  <ion-button color="primary" expand="block" (click)="refund()"
    >Refund to card</ion-button
  >
</ion-footer>
